import React, { useRef, useEffect } from "react"
import styled from "styled-components"
import Slick from "react-slick"
import i18n from "@/i18n";
import { Trans } from 'react-i18next'

const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    }).replace(/\./g, '.')
}

const StatsHeading = styled.h1`
    width: 100%;
    overflow: hidden;
    color: rgba(131, 195, 8, 1);
    letter-spacing: -0.68px;
    padding: 60px 0 20px 0;
    font: 800 34px;
`

const HighlightText = styled.span`
    color: rgba(34, 34, 34, 1);
`

const RatingContainer = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`

const StarImage = styled.img`
    width: 20px;
    height: 20px;
    object-fit: contain;
`

const Card = styled.article`
    margin: 10px 10px 40px 10px;
    border-radius: 12px;
    background-color: #f9f9f9;
    box-shadow: 12px 12px 30px rgba(0, 0, 0, 0.25);
    width: 462px !important;
    height: 255px !important;
    padding: 16px 20px;
    overflow: hidden;
`

const Header = styled.header`
    display: flex;
    flex-direction: column;
    width: 100%;
`

const AuthorInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 5px;
`

const Author = styled.span`
    color: #515151;
    font: 700 16px Pretendard, sans-serif;
`

const DateItem = styled.time`
    color: #515151;
    font: 500 16px Pretendard, sans-serif;
`

const Content = styled.div`
    margin-top: 12px;
`

const Title = styled.h2`
    color: #515151;
    font: 700 16px Pretendard, sans-serif;
    margin: 0;
    text-align: left;
`

const Description = styled.p`
    color: #515151;
    font: 500 16px Pretendard, sans-serif;
    letter-spacing: -0.32px;
    line-height: 24px;
    margin: 4px 0 0;
    text-align: left;
`

const Container = styled.main`
    width: 100vw;
`


function StarRating({ rating }) {
    return (
        <RatingContainer>
            {[...Array(5)].map((_, index) => (
                <StarImage
                    key={index}
                    src="https://front.videomonster.com/images-u6yd72dy/common/newlanding2024/rating_star.png"
                    alt={index < rating ? "Filled star" : "Empty star"}
                    loading="lazy"
                />
            ))}
        </RatingContainer>
    )
}

function ReviewCard({ author, date, title, content, rating }) {
    return (
        <Card>
            <Header>
                <StarRating rating={rating} />
                <AuthorInfo>
                    <Author>{author}</Author>
                    <DateItem>{formatDate(date)}</DateItem>
                </AuthorInfo>
            </Header>
            <Content>
                <Title>{title}</Title>
                <Description>{content}</Description>
            </Content>
        </Card>
    )
}
  
const ReviewList = () => {
    const slickRef1 = useRef(null)
    let slick1ChangeTime = Date.now()
    let interval

    const reviewData = [
        {
            author: i18n.t("common.landing.review.name_1"),
            date: "2024.9.25",
            title: i18n.t("common.landing.review.title_1"),
            content: i18n.t("common.landing.review.content_1"),
            rating: 5
        },
        {
            author: i18n.t("common.landing.review.name_2"),
            date: "2024.11.25",
			title: i18n.t("common.landing.review.title_2"),
            content: i18n.t("common.landing.review.content_2"),
            rating: 5
        },
        {
            author: i18n.t("common.landing.review.name_3"),
            date: "2024.11.25",
			title: i18n.t("common.landing.review.title_3"),
            content: i18n.t("common.landing.review.content_3"),
            rating: 5
        },
        {
            author: i18n.t("common.landing.review.name_4"),
            date: "2024.11.25",
			title: i18n.t("common.landing.review.title_4"),
            content: i18n.t("common.landing.review.content_4"),
            rating: 5
        },

        // 개수가 너무 적어서 4개 복사해서 붙여둠.
        {
            author: i18n.t("common.landing.review.name_1"),
            date: "2024.9.25",
            title: i18n.t("common.landing.review.title_1"),
            content: i18n.t("common.landing.review.content_1"),
            rating: 5
        },
        {
            author: i18n.t("common.landing.review.name_2"),
            date: "2024.11.25",
			title: i18n.t("common.landing.review.title_2"),
            content: i18n.t("common.landing.review.content_2"),
            rating: 5
        },
        {
            author: i18n.t("common.landing.review.name_3"),
            date: "2024.11.25",
			title: i18n.t("common.landing.review.title_3"),
            content: i18n.t("common.landing.review.content_3"),
            rating: 5
        },
        {
            author: i18n.t("common.landing.review.name_4"),
            date: "2024.11.25",
			title: i18n.t("common.landing.review.title_4"),
            content: i18n.t("common.landing.review.content_4"),
            rating: 5
        },
    ]

    const slickSetting = {
        infinite: true,
        speed: 500,
        touchThreshold: 10,
        slidesToScroll: 1,
        swipeToSlide: false,
        variableWidth: true
    }

    useEffect(() => {
        interval = setInterval(slickAnimationInterval, 500)
        
        return () => {
            clearInterval(interval)
        }
    })

    const slickAnimationInterval = () => {
        const now = Date.now()
        if (now - slick1ChangeTime >= (1000 + Math.floor(Math.random() * 10000)) && slickRef1) {
            slickRef1.current.slickNext()
            slick1ChangeTime = now
        }
    }

    return (
        <Container>
            <Slick {...slickSetting} ref={slickRef1}>
                {reviewData.map((review, index) => (
                    <ReviewCard
                        key={index}
                        {...review}
                    />
                ))}
            </Slick>
        </Container>
    )
}

export default function ReviewSection() {
    return (
        <section>
            <StatsHeading>
				<Trans i18nKey="common.landing.review.text"><HighlightText /></Trans>
            </StatsHeading>
            <ReviewList />
        </section>
    )
}
